<app-navbar></app-navbar>
<section class="section">
    <router-outlet></router-outlet>
</section>
<!-- <app-live-rolls-bottom-pin></app-live-rolls-bottom-pin> -->